import { paginated_factory, backend_api } from '/src/utils/api.js'
import { today } from '/src/utils/time'
import { useAppStore } from '/src/stores/app'
import bus from '/src/utils/event_bus'

let LASTS = {}
let LOADING_PROMISES = {}

export default {
    actions: {
        // MULTIPLE
        setter(store_keyword) {
            function setter_mutation(data) {
                this[store_keyword] = data
            }
            return setter_mutation
        },
        // SINGLE
        creator(store_keyword) {
            function creator_mutation(data) {
                this[store_keyword].push(data)
            }
            return creator_mutation
        },
        updater(store_keyword) {
            function updater_mutation(updated) {
                console.log(`[UPDATER] Updating ${store_keyword} with data:`, updated);
                const i = this[store_keyword].findIndex(obj => (obj?.uuid || obj?.id) == (updated?.uuid || updated?.id))
                if (i !== -1) {
                    console.log(`[UPDATER] Found existing item at index ${i}, updating...`);
                    // Create a new array with the updated item
                    const newArray = [...this[store_keyword]]
                    // Ensure the updated item is a fresh object
                    newArray[i] = { ...updated }
                    // Trigger reactivity by assigning the new array
                    this[store_keyword] = newArray
                } else {
                    console.log(`[UPDATER] Item not found, adding to array...`);
                    // If item not found, add it to the array
                    this[store_keyword] = [...this[store_keyword], { ...updated }]
                }

                // Emit event for specific object types
                const uuid = updated?.uuid || updated?.id;
                if (store_keyword === 'rsos' && uuid) {
                    console.log(`[UPDATER] Emitting rso/refreshed event for UUID:`, uuid);
                    bus.emit('rso/refreshed', { uuid, data: updated });
                } else if (store_keyword === 'work_orders' && uuid) {
                    console.log(`[UPDATER] Emitting wo/refreshed event for UUID:`, uuid);
                    bus.emit('wo/refreshed', { uuid, data: updated });
                }
            }
            return updater_mutation
        },
        remover(store_keyword) {
            function remover_mutation(uuid) {
                this[store_keyword] = [...this[store_keyword].filter(obj => (obj?.uuid || obj.id) != uuid)]
            }
            return remover_mutation
        },


        // MULTIPLE
        loader(url, objs_name) {
            function loader_action(params = null) {
                const app_store = useAppStore()
                app_store.pushLoading(objs_name)
                // If params are provided, build query string
                let fullUrl = url;
                let cacheKey = url;

                if (params) {
                    const queryString = Object.keys(params)
                        .filter(key => params[key] !== null && params[key] !== undefined && params[key] !== '')
                        .map(key => `${key}=${encodeURIComponent(params[key])}`)
                        .join('&');

                    if (queryString) {
                        fullUrl = `${url}?${queryString}`;
                        cacheKey = fullUrl;
                    }
                }

                // Register last call (ensure last response wins)
                const lastKey = `${url}__${objs_name}__loader`;
                LASTS[lastKey] = fullUrl;

                // Si ya hay una promesa en curso para esta URL, retornarla
                if (LOADING_PROMISES[cacheKey]) {
                    return LOADING_PROMISES[cacheKey]
                }

                // Si no, crear nueva promesa y guardarla
                const promise = paginated_factory(fullUrl)
                    .then(({ data }) => {
                        // Accept last
                        if (LASTS[lastKey] === fullUrl) {
                            this['set' + objs_name](data)
                        } else {
                            console.log("[i] Rejecting loader commit. Not last call.")
                        }
                        delete LOADING_PROMISES[cacheKey] // Limpiar al terminar
                        return data
                    })
                    .catch(e => {
                        console.log(`Cant get ${objs_name}: ${e}`)
                        delete LOADING_PROMISES[cacheKey] // Limpiar en caso de error
                        throw e // Re-throw para mantener la cadena de errores
                    })
                    .finally(() => app_store.popLoading(objs_name))

                LOADING_PROMISES[cacheKey] = promise
                return promise
            }
            return loader_action
        },
        loader_query(url, objs_name) {
            const keyword = `${url}__${objs_name}`
            function loader_action(payload) {

                let query = Object.keys(payload).map(key => key + '=' + payload[key]).join('&')
                // Register last call (ensure last called fills)
                LASTS[keyword] = query

                return paginated_factory(`${url}/?${query}`)
                    .then(({ data }) => {
                        // Accept last
                        if (LASTS[keyword] == query)
                            this['set' + objs_name](data)
                        // Reject prebounce
                        else console.log("[i] Rejecting loader commit. Not last call.")
                        return data
                    })
                // .catch(e => {
                // console.log(`Cant get ${objs_name}: ${e}`)
                // })
            }
            return loader_action
        },
        loader_pr(url, objs_name) {
            const keyword = `${url}__${objs_name}`
            function loader_action(project_uuid) {
                const app_store = useAppStore()
                app_store.pushLoading(objs_name)

                // Register last call (ensure last called fills)
                LASTS[keyword] = project_uuid

                // Clean previous
                this['set' + objs_name]([])

                // If project is "all", query as null
                let query_pr = project_uuid == "all" ? null : project_uuid
                return paginated_factory(`${url}?project=${query_pr}`)
                    .then(({ data }) => {
                        // Accept last
                        if (LASTS[keyword] == project_uuid)
                            this['set' + objs_name](data)
                        // Reject prebounce
                        else console.log("[i] Rejecting loader commit. Not last call.")
                        return data
                    })
                    .catch(e => {
                        console.log(`Cant get ${objs_name}: ${e}`)
                    })
                    .finally(() => app_store.popLoading(objs_name))
            }
            return loader_action
        },
        loader_date(url, objs_name) {
            const keyword = `${url}__${objs_name}__bydate`
            function loader_action(prod_date) {

                // Register last call (ensure last called fills)
                LASTS[keyword] = prod_date

                // Clean previous
                this['set' + objs_name]([])

                // If today, previous panels are also needed
                let api_promise
                if (prod_date == today()) {
                    api_promise = backend_api(`${url}today_and_delayed/`)
                } else {
                    api_promise = paginated_factory(`${url}?scheduled_prod_date=${prod_date}`)
                }

                return api_promise.then(({ data }) => {
                    // Accept last
                    if (LASTS[keyword] == prod_date)
                        this['set' + objs_name](data)
                    // Reject prebounce
                    else console.log("[i] Rejecting loader commit. Not last call.")
                    return data
                })
                    .catch(e => {
                        console.log(`Cant get ${objs_name}: ${e}`)
                    })
            }
            return loader_action
        },

        // SINGLE
        poster(url, obj_name) {
            function poster_action(payload) {
                return backend_api.post(url, payload)
                    .then(({ data }) => {
                        // obj_name can be an array
                        if (Array.isArray(obj_name)) {
                            obj_name.forEach(name => {
                                this['create' + name](data)
                            })
                        } else {
                            this['create' + obj_name](data)
                        }
                        return { data }
                    })
                    .catch(e => console.log(`Cant create ${obj_name}: ${e}`))
            }
            return poster_action
        },
        putter(url, obj_name) {
            function putter_action(payload) {
                // Store original state in case we need to rollback
                let originals = []
                if (Array.isArray(obj_name)) {
                    obj_name.forEach(name => {
                        originals.push(this[name.toLowerCase()]?.find(
                            item => (item?.uuid || item?.id) === (payload?.uuid || payload?.id)
                        ))
                    })
                } else {
                    originals.push(this[obj_name.toLowerCase()]?.find(
                        item => (item?.uuid || item?.id) === (payload?.uuid || payload?.id)
                    ));
                }

                return backend_api.put(url + (payload?.uuid || payload?.id) + "/", payload)
                    .then(({ data }) => {
                        if (Array.isArray(obj_name)) {
                            obj_name.forEach(name => {
                                this['update' + name](data)
                            })
                        } else {
                            this['update' + obj_name](data)
                        }
                        return { data }
                    })
                    .catch(e => {
                        // Rollback on error
                        if (Array.isArray(obj_name)) {
                            obj_name.forEach(name => {
                                this['update' + name](originals.shift())
                            })
                        } else {
                            this['update' + obj_name](originals.shift())
                        }
                        console.error(`Can't update ${obj_name}:`, e)
                        throw e // Re-throw to handle in components
                    })
            }
            return putter_action
        },
        deleter(url, obj_name) {
            function deleter_action(uuid) {
                return backend_api.delete(url + uuid + '/')
                    .then(() => {
                        this['remove' + obj_name](uuid)
                    })
                    .catch(e => console.log(`Cant delete ${obj_name}: ${e}`))
            }
            return deleter_action
        },
        refresher(url, obj_name) {
            function refresher_action(uuid) {
                console.log(`[REFRESHER] Starting refresh for ${obj_name} with UUID:`, uuid);
                return backend_api.get(url + uuid + "/")
                    .then(({ data }) => {
                        console.log(`[REFRESHER] Successfully fetched ${obj_name} data:`, data);
                        this['update' + obj_name](data)
                        console.log(`[REFRESHER] Updated ${obj_name} in store`);
                        return { data }
                    })
                    .catch(e => {
                        console.error(`[REFRESHER] Error updating ${obj_name}:`, e);
                        throw e;
                    })
            }
            return refresher_action
        },
        multi_refresher(url, obj_name) {
            function refresher_action(uuids) {
                if (uuids.length == 0) {
                    // Return a fulfilled promise with an empty object if the uuids came empty
                    return Promise.resolve({ data: { results: [] } });
                    // Otherwise, the backend gets an empty filter so it returns a non filtered query
                }
                return backend_api.get(`${url}?uuid__in=${uuids.join(",")}`)
                    .then(({ data }) => {
                        data.results.forEach(obj => this['update' + obj_name](obj))
                        return { data }
                    })
                    .catch(e => console.log(`Cant update ${obj_name}: ${e}`))
            }
            return refresher_action
        },
    }
}
